// Permitted letters depend upon their position in the postcode.
const alpha1 = "[abcdefghijklmnoprstuwyz]";
const alpha2 = "[abcdefghklmnopqrstuvwxy]";
const alpha3 = "[abcdefghjkpmnrstuvwxy]";
const alpha4 = "[abehmnprvwxy]";
const alpha5 = "[abdefghjlnpqrstuwxyz]";

/**
 * Check if passed postcode is valid.
 * @param  {String} postcode Postcode to analyse
 * @return {Boolean}         If postcode is valid or not
 */
const postcodeValidation = (ogPostcode) => {
  const postcode = ogPostcode.toLowerCase().replace(/\s/g, "");

  // prettier-ignore
  const regexes = [
    new RegExp(`^(${alpha1}{1}${alpha2}{0,1}[0-9]{1,2})([0-9]{1}${alpha5}{2})$`, 'i'),
    new RegExp(`^(${alpha1}{1}[0-9]{1}${alpha3}{1})([0-9]{1}${alpha5}{2})$`, 'i'),
    new RegExp(`^(${alpha1}{1}${alpha2}{1}[0-9]{1}${alpha4})([0-9]{1}${alpha5}{2})$`, 'i'),
    new RegExp(`gir0aa`, 'i'),
    new RegExp(`^(bfpo)[0-9]{1,4}`, 'i'),
    new RegExp(`^([a-z]{4})(1zz)`, 'i'),
    new RegExp(`^ai-2640`, 'i')
  ];

  return !regexes.every((r) => {
    return !r.test(postcode);
  });
};

export default postcodeValidation;
